import http from "../../http-common";

class OneKidsConfigService {
    getConfigsByFilters(type, configName, variableName, page, limit) {
        return http.get(`/onekids/configs/search`, {params: {type, configName, variableName, page, limit}});
    }
    createOneKidsConfig(data) {
        return http.post(`/onekids/configs/create`, data);
    }
    updateOneKidsConfig(id, data) {
        return http.post(`/onekids/configs/update/${id}`, data);
    }

    deleteOneKidsConfig(id) {
        return http.delete(`/onekids/configs/delete/${id}`);
    }



}

export default new OneKidsConfigService();